import { Form, Formik } from 'formik';
import { isEmpty } from 'lodash';
import React, { useEffect } from 'react';
import { FormElement } from '@dashboard/components/Form';
import FormSubmit from '@dashboard/components/Formik/components/FormSubmit';
import PageSelect from '@/dashboard/components/Formik/components/PageSelect';
import FormError from '@dashboard/components/Formik/components/FormError';
import { AfterPaymentActionEnum } from '@dashboard/enums/after-payment';
import { transformApiErrorToFormik } from '@dashboard/services/form';
import { usePreview } from '@dashboard/context/PreviewContext';
import usePage from '@/dashboard/hooks/usePage';

const CheckoutRedirectForm = () => {
  const { page, updatePage } = usePage();
  const [, previewDispatch] = usePreview();
  const setPreview = value => previewDispatch({ type: 'set', value });

  return (
    <Formik
      initialValues={{
        afterPaymentAction: page.afterPaymentAction,
        redirectCheckout: page.redirectCheckout,
      }}
      onSubmit={async (values, actions) => {
        actions.setStatus(undefined);

        const { data, error } = await updatePage.mutateAsync(values);

        if (data) {
          if (data.afterPaymentAction === AfterPaymentActionEnum.CHECKOUT) {
            setPreview({
              type: 'checkout',
            });
          }

          actions.setStatus('');
          actions.resetForm({
            values: {
              afterPaymentAction: data.afterPaymentAction,
              redirectCheckout: data.redirectCheckout,
            },
          });
        } else {
          const { status, errors } = transformApiErrorToFormik(error);

          if (!isEmpty(errors)) {
            actions.setErrors(errors);
          } else {
            actions.setStatus(status);
          }
        }
      }}
    >
      {({ status, dirty, setFieldValue, handleSubmit, isSubmitting }) => {
        useEffect(() => {
          setFieldValue('afterPaymentAction', AfterPaymentActionEnum.CHECKOUT);
        }, []);

        return (
          <Form onSubmit={handleSubmit}>
            <FormElement>
              <PageSelect
                showLabel={true}
                name="redirectCheckout"
                pageTypes={['checkout', 'event', 'form']}
              />

              <FormError name="redirectCheckout" />
            </FormElement>
            <FormElement>{status && status}</FormElement>
            <FormSubmit>
              <FormSubmit.Button>Save</FormSubmit.Button>
              <FormSubmit.State visible={!!dirty && !isSubmitting} />
            </FormSubmit>
          </Form>
        );
      }}
    </Formik>
  );
};

export default CheckoutRedirectForm;
